import { loadable } from 'jotai/utils';
import { userAtom } from '~/atoms/user';
import { useAtom } from 'jotai';
const loadableAtom = loadable(userAtom);
export const useUser = () => {
    const [loading] = useAtom(loadableAtom);
    return {
        user: loading.state === 'hasData' ? loading.data : undefined,
        userLoadingState: loading.state
    };
};
